﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/Policies`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'GetPendingPoliciesByNPN' }]);

const GetPendingPoliciesByNPN = (queries) =>
  api.endpoints.GetPendingPoliciesByNPN.getMultipleQueryString(queries);

export { GetPendingPoliciesByNPN };
